module.exports = __webpack_public_path__ + "static/media/maturity_model_EN.805bf91f.png";